import React from "react";
import EPCalendar from "./EPCalendar";

// Page « Calendrier des EP » : l'en-tête et la mise en page vivent dans
// EPCalendar (kit DataList : list-page, list-card).
const EP = () => <EPCalendar />;

export default EP;
